import React from 'react';
import { isAllSwagCategory } from '../../../../../redux/product-listing/product-listing.utils';
export const isShowSelectAll = filterName => {
  return isAllSwagCategory() && filterName !== 'Category' || !isAllSwagCategory();
};
export const lowercaseConjunction = title => {
  const conjunctions = ['and', 'to'];
  const words = title.split(' ');
  const modifiedWords = words.map((word, index) => {
    if (conjunctions.includes(word)) {
      return /*#__PURE__*/React.createElement("span", null, word, "\xA0");
    }
    if (index === words.length - 1) {
      return word;
    }
    return `${word} `;
  });
  return modifiedWords;
};